module.exports = __webpack_public_path__ + "static/img/file_txt.4567dffd.png";